module.exports = __webpack_public_path__ + "static/media/19ESCAP10.25a7ce86.jpg";